export class Goal {
    minute: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/goal.model.ts